import { Component, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { CollegeBatchModel } from 'src/app/models/collegeBatchModel';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { ToastrService } from 'ngx-toastr';
import { CollegeBatchConstant } from 'src/app/constants/label-constants';
import { DeleteDialogboxComponent } from '../delete-dialogbox/delete-dialogbox.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CollegeBatchViewComponent } from './college-batch-view/college-batch-view.component';
import { CollegeBatchAddEditComponent } from './college-batch-add-edit/college-batch-add-edit.component';
import { StatusDialogboxComponent } from '../status-dialogbox/status-dialogbox.component';
import { CommonConstant, NoRecordFound } from 'src/app/constants/common-constant';

@Component({
  selector: 'app-college-batch-list',
  templateUrl: './college-batch-list.component.html',
  styleUrls: ['./college-batch-list.component.scss']
})
export class CollegeBatchListComponent {
  receiptContent: any = [];
  enterSearch: string = '';
  searchClose: boolean = false;
  SortColumn: any = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  showData: boolean = false;
  displayedColumns: string[] = ['rowNumber', 'collegeName', 'batchName', 'batchYear', 'TotalStudents', 'isActive', 'Action'];
  dataSource: MatTableDataSource<CollegeBatchModel> = new MatTableDataSource();
  collegeBatchStatusObj: any = {};
  collegeBatchDeleteObj: any = {};
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  CollegeBatchList: any = [];
  CommonConstant: any = [];
  NoRecordFound: any = [];
  CollegeBatchConstant: any = [];
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private EncrDecr: EncrDecrService,
    private toastr: ToastrService,
    private modalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.CollegeBatchConstant = CollegeBatchConstant;
    this.CommonConstant = CommonConstant
    this.NoRecordFound = NoRecordFound
    this.getCollegeBatchList();
    this.sharedService.setData('College Batch');
  }

  getCollegeBatchList() {
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.collageBatch.GetCollegeBatchList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.showData = true;
          let TotalRecords = 0;
          this.CollegeBatchList = response.data
          this.dataSource.data = this.CollegeBatchList;

          if (this.CollegeBatchList.length > 0) {
            TotalRecords = this.CollegeBatchList[0].totalRecords;
            this.totalRows = TotalRecords;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }

  SortChange(event) {
    this.sortDirection = event.direction ? event.direction : 'asc';
    this.SortColumn = event.active;
    this.getCollegeBatchList();
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage =0;
      this.getCollegeBatchList();
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.enterSearch = event.target.value;
      this.getCollegeBatchList();
      this.searchClose = true;
    }
  }

  pageChanged(event) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getCollegeBatchList();
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getCollegeBatchList();
    this.searchClose = false;
  }

  Addbatch(collegeBatchId: number) {
    const modalRef = this.modalService.open(CollegeBatchAddEditComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.collegeBatchId = collegeBatchId;
    modalRef.result.then((result) => {
      if (result === 'save') {
        this.getCollegeBatchList();
      }
    }).catch((error) => {
    });
  }

  BatchListDetail(collegeBatchId: number) {
    const modalRef = this.modalService.open(CollegeBatchViewComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.collegeBatchId = collegeBatchId;
    modalRef.result.then((result) => {
    }).catch((error) => {
    });
  }

  Deletepopup(collegeBatchId: number, batchName: string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.collegeBatchDeleteObj = {
      collegeBatchId: collegeBatchId,
      collegeBatchname: batchName,
      element: 'college batch'
    }
    modalRef.componentInstance.collegeBatchDeleteObj = this.collegeBatchDeleteObj;
    modalRef.result.then((result) => {
      if (result === 'delete') {
        this.getCollegeBatchList();
      }
    }).catch((error) => {
    });
  }

  onStatus(collegeBatchId: number, collegeBatchname: string, active: boolean) {
    const modalRef = this.modalService.open(StatusDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.collegeBatchStatusObj = {
      collegeBatchId: collegeBatchId,
      collegeBatchname: collegeBatchname,
      activeBatch: active
    }
    modalRef.componentInstance.collegeBatchStatusObj = this.collegeBatchStatusObj;
    modalRef.result.then((result) => {
      if (result === 'status') {
        this.CollegeBatchList.forEach((element: { collegeBatchId: number; isActive: boolean; }) => {
          if (element.collegeBatchId == collegeBatchId) {
            element.isActive = active ? false : true
          }
        });
      }
    }).catch((error) => {
    });
  }
}
